import sanitize from 'sanitize-filename';

export const buildJobMaterialFileName = (jobName: string, fileName: string) => {
  const safeJobName = sanitize(jobName || 'job');
  const safeFileName = sanitize(fileName);
  if (safeFileName === safeJobName || safeFileName.startsWith(`${safeJobName}.`)) {
    return safeFileName;
  }
  const existingPrefix = [`${safeJobName}_`, `${safeJobName} `, `${safeJobName}-`].find((prefix) =>
    safeFileName.startsWith(prefix),
  );
  const fileType = existingPrefix ? safeFileName.slice(existingPrefix.length) : safeFileName;

  return `${safeJobName}_${fileType}`;
};
